//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { TariffUsageSchemeRateDTO } from 'src/app/core/models/system/tariff/tariff-usage-scheme-rate.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class TariffsUsageSchemeRateService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffUsageSchemeRateDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsUsageSchemeRates +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(tariffUsageSchemeRate: TariffUsageSchemeRateDTO): Observable<TariffUsageSchemeRateDTO> {
    try {
      //JSON.stringify(tariffUsageSchemeRate)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffUsageSchemeRate))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsUsageSchemeRates +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(tariffUsageSchemeRate: TariffUsageSchemeRateDTO): Observable<TariffUsageSchemeRateDTO> {
    try {
      //JSON.stringify(tariffUsageSchemeRate)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(tariffUsageSchemeRate))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsUsageSchemeRates +
                                                              "?id=" + tariffUsageSchemeRate.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(tariffUsageSchemeRate: TariffUsageSchemeRateDTO): Observable<any> {
    try {
      //JSON.stringify(tariffUsageSchemeRate);

      if (tariffUsageSchemeRate.id && <number>tariffUsageSchemeRate.id>0)
        return this.put(tariffUsageSchemeRate);
      
      return this.post(tariffUsageSchemeRate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
